import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  // we init with resources
  resources: {
    de: {
      translations: {},
    },
    /* de: {
        translations: mockTranslations
      } */
  },
  fallbackLng: 'de',
  debug: false,

  ns: ['translations'],
  defaultNS: 'translations',

  keySeparator: false,

  interpolation: {
    escapeValue: false, // react already escapes
  },
});

export default i18n;
